export default "__VITE_ASSET__bWEezDbl__"